// UploadGuidelines_refactored v1: 重构后的上传指南主组件
// 从 UploadGuidelines.js 重构而来，使用模块化组件和自定义Hook

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';

import {
  GuidelinesHeader,
  DosAndDonts,
  VisualExamples,
  CommunityNotice,
  ConfirmationSection,
} from './components';
import { useGuidelinesState, useGuidelinesActions } from './hooks';

/**
 * UploadGuidelines_refactored 组件 - 重构后的上传指南页面
 * @returns {JSX.Element} 上传指南页面
 */
const UploadGuidelines_refactored = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // 使用自定义Hook管理状态
  const { guidelinesConfirmed, handleCheckboxChange } = useGuidelinesState();

  // 使用自定义Hook管理操作
  const { handleConfirm } = useGuidelinesActions({
    guidelinesConfirmed,
    user,
  });

  return (
    <div className='min-h-screen bg-gray-50 flex flex-col'>
      {/* Back icon when navigated from Edit Profile */}
      {location.state?.from === 'edit-profile' && (
        <div className='p-4'>
          <button
            aria-label='Back'
            onClick={() => navigate(-1)}
            className='text-gray-600 hover:text-gray-900 transition-colors duration-200 rounded-md p-2'
          >
            <svg
              className='w-5 h-5'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M10 19l-7-7m0 0l7-7m-7 7h18'
              />
            </svg>
          </button>
        </div>
      )}

      {/* Main Content */}
      <div className='flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8'>
        <div className='max-w-4xl w-full space-y-8'>
          {/* Guidelines Card */}
          <div className='bg-white rounded-lg p-8'>
            {/* Header */}
            <GuidelinesHeader />

            {/* Guidelines Content */}
            <div className='space-y-8'>
              {/* Do's and Don'ts */}
              <DosAndDonts />

              {/* Visual Examples */}
              <VisualExamples />

              {/* Community Review Notice */}
              <CommunityNotice />
            </div>

            {/* Confirmation Section */}
            <ConfirmationSection
              guidelinesConfirmed={guidelinesConfirmed}
              onCheckboxChange={handleCheckboxChange}
              onConfirm={handleConfirm}
              user={user}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadGuidelines_refactored;
